import { getPortalConfig, usePortalConfig } from "../../config/portalConfig";
import { COUNTRY_CODE_KEY } from "../../setCountryConfig";

export type CookieConsentValue = "unset" | `${boolean}`;

export const isCookieConsentUnset = (
  consent: Record<string, CookieConsentValue>
) =>
  Object.values(consent).some(
    (onesaasConsentValue) => onesaasConsentValue === "unset"
  );

export const isSomeCookieConsentGranted = (
  consent: Record<string, CookieConsentValue>
) => Object.values(consent).some((value) => value === "true");

const countryCodes = new Set([
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "GB",
  "NO",
  "CH",
]);

export const getShouldHandleConsent = (): boolean => {
  const country = getPortalConfig(COUNTRY_CODE_KEY);
  if (!country) {
    return false;
  }
  if (!["prod", "stg"].includes(window.SHELL_ENV.ENV)) {
    return false;
  }
  return countryCodes.has(country);
};

export const useIsConsentRequired = (): boolean => {
  const country = usePortalConfig(COUNTRY_CODE_KEY);
  if (!country) {
    return false;
  }
  if (!["prod", "stg"].includes(window.SHELL_ENV.ENV)) {
    return false;
  }
  return countryCodes.has(country);
};
